import { atom } from 'jotai';
import { CurrencyCrossObj, Inventory, InventoryWithListedInstrument } from '../../types';
import { Loadable, LoadableState } from '../../utils';

export type InventoryDetails = LoadableState<{
  tradableInventories?: Array<InventoryWithListedInstrument>;
  nonTradableInventories?: Array<Inventory>;
  inventories: Array<Inventory>;
  currencyCrosses: Array<CurrencyCrossObj>;
}>;

export type InventoryDetailsMaybe = InventoryDetails;

export const inventoryDetailsAtom = atom<InventoryDetailsMaybe>(Loadable.loading);
